import { TextBig } from '../../OrdersTable/index.styled'
import { getDistanceInKm } from '../../../../../helper'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextWrap, TextWrapper, DistanceBlock, GuestName, GuestRoom } from './index.styled'
import NewBlock from './NewBlock'
import { getRoomChargeRoomNumber, getRoomChargeSignerName } from '../../../../RoomCharge/helper'

const CustomerData = React.memo(({ item }) => {
	const { t } = useTranslation()
	const guestName = getRoomChargeSignerName(item)
	const roomNumber = getRoomChargeRoomNumber(item)
	const isDeliveryByPlatform = item?.orderType === 'DELIVERY_BY_PLATFORM'
	const partnerDeliveryMetaData = item?.deliveryMetaData?.partner
	const updatedDeliveryByPlatform = !!(item?.orderType === 'DELIVERY' && partnerDeliveryMetaData?.type && partnerDeliveryMetaData?.pickupEta)
	const isPlatformDriverOrder = isDeliveryByPlatform || updatedDeliveryByPlatform
	const isPartnerDriverOrder = partnerDeliveryMetaData?.deliveryId
	const isNewCustomer = item?.customer?.closedOrdersCount === 0
	const beeperCode = item?.pickupMetaData?.beeperCode || item?.kioskMetaData?.beeperCode
	const isTicketOrder = !!item?.ticketMetaData

	return (
		<>
			{item.orderType === 'RESTAURANT' && <>
				<TextBig>{`${item.restaurantMetaData?.area.name} ${t('order.table.table')} ${item.restaurantMetaData?.table.number}`}</TextBig>
				{!!guestName && <GuestName>{guestName}</GuestName>}
				{!!roomNumber && <GuestRoom>{t('RoomCharge.room', { room: roomNumber })}</GuestRoom>}
			</>}
			{(item.orderType === 'PICKUP' || item.orderType === 'COUNTER') &&
				<TextWrapper>
					<TextBig className="mg-bt">
						{t(isTicketOrder ? 'order.table.ticketSale' : `order.table.${item.orderType}`)}
						{beeperCode && t('order.table.pagerCode', { beeperCode })}
					</TextBig>
					{roomNumber ?
						<>
							{!!guestName && <GuestName>{guestName}</GuestName>}
							<GuestRoom>{t('RoomCharge.room', { room: roomNumber })}</GuestRoom>
						</> :
						<>
							<TextWrap>
								<TextBig>{item.customer?.name}</TextBig>
								{isNewCustomer && <NewBlock />}
							</TextWrap>
							<p className="phoneNumber">{item.customer?.phoneNumber}</p>
						</>}
				</TextWrapper>}
			{item.orderType === 'DELIVERY' && (!isPlatformDriverOrder || isPartnerDriverOrder) &&
				<>
					<TextWrap>
						<TextBig>{item.customer?.name}</TextBig>
						{isNewCustomer && <NewBlock />}
					</TextWrap>
					<p className="street">{item.customer.street} {item.customer.streetNumber}, {item.customer.postalCode}
						<DistanceBlock className={(!isNaN(+item.customer.geoData?.distance) && item.customer.geoData?.distance > 0) ? '' : 'lf-hidden'}>
							{getDistanceInKm(item.customer.geoData?.distance)} km
						</DistanceBlock>
					</p>
				</>}
			{isPlatformDriverOrder && !isPartnerDriverOrder &&
				<TextBig>{t(`order.table.platform_driver.${item?.platformMetaData?.platformType}`)}</TextBig>}
		</>)
})

CustomerData.displayName = 'CustomerData'
export default CustomerData
